<app-compliance-nav [activeMenuItem]="'risk'"></app-compliance-nav>

<mat-card class="content-card">

  <div [hidden]="!isLoadingStats">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

    <div style="width: 100%;" *ngIf="stats != null">
      <div fxFlex="10">
        <div class="sts-box" style="text-align: center; border: 1px solid grey; background: rgba(0,128,0,0.6);">
          Low<br />
          {{stats.riskLowPercentage}} %
        </div>
      </div>
      <div fxFlex="10">
        <div class="sts-box" style="text-align: center; border: 1px solid grey; background: rgba(255,132,0,0.49)">
          Medium<br />
          {{stats.riskMediumPercentage}} %
        </div>
      </div>
      <div fxFlex="10">
        <div class="sts-box" style="text-align: center; border: 1px solid grey; background: rgba(255,0,0,0.6);">
          High<br />
          {{stats.riskHighPercentage}} %
        </div>
      </div>
    </div>

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">

        <mat-form-field>
          <mat-label>Risk Level</mat-label>
          <mat-select [formControl]="riskLevelSelect" (selectionChange)="onRiskLevelChange()" multiple>
            <mat-option [value]="'0'">Low</mat-option>
            <mat-option [value]="'1'">Medium</mat-option>
            <mat-option [value]="'2'">High</mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="!currentUserIsIssuerExternal()">
          <mat-form-field class="brand-filter-field">
            <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" multiple>
              <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>


        <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
          <mat-form-field style="width: 400px;" class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="table.filters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>

    </div>

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table" style="margin-right: 60px;">
        <button mat-raised-button  [disabled]="isDownloadingRiskReport" [class.spinner]="isDownloadingRiskReport" (click)="downloadRiskReport()">
          <mat-icon>download</mat-icon> Download Risk Report
        </button>

        <button mat-raised-button [disabled]="isDownloadingCardActivitiesReport" [class.spinner]="isDownloadingCardActivitiesReport"  (click)="downloadCardActivitiesReport()" style="margin-right: 60px;">
          <mat-icon>download</mat-icon> Download Card Activity Report
        </button>

        <button mat-raised-button [disabled]="isDownloadingNonAllGoodCardsReport" [class.spinner]="isDownloadingNonAllGoodCardsReport"  (click)="downloadNonAllGoodCardsReport()" style="margin-right: 60px;">
          <mat-icon>download</mat-icon> Download Non All Good Cards Report
        </button>
      </div>
    </div>



  </div>

  <div style="margin-top: 20px;">

  </div>
  <app-mat-table-generator #table
                           tableName="riskLvlOverviewTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getCustomerOverviewLink"
  >
  </app-mat-table-generator>

</mat-card>
